<ng-container *transloco="let t">
  <form [formGroup]="profileForm" *ngIf="profileForm" (ngSubmit)="verify()">
    <div *ngIf="showError" class="warning-info" style="color: red;">
      {{ t("challenge.InvalidDetails") }}
    </div>
    <p>{{ t("setPassword.Welcome") }} {{ name }} !</p>
    <p class="wc-content">
      {{
      forgotpass
      ? t("setPassword.ForgotPasswordWelcomeContent")
      : t("setPassword.Welcome Content")
      }}
    </p>
    <div class="mob-code-component user-ngx-input" [ngClass]="{ invalid:
    !validate('mobileNumber')?.hasError('required') &&
    validate('mobileNumber')?.hasError('validatePhoneNumber') &&
    validate('mobileNumber')?.touched
}">
      <label class="label">{{ t("challenge.MobileNumber") }}</label>
      <ngx-intl-tel-input [cssClass]="'mobile-code-input'" [enablePlaceholder]="true" [searchCountryFlag]="true"
        [selectedCountryISO]="selectedCountry" [onlyCountries]="onlyCountries" [maxLength]="15" [phoneValidation]="true"
        [id]="'phone'" [separateDialCode]="true" name="phone" formControlName="mobileNumber"></ngx-intl-tel-input>
      <mat-error *ngIf="
            validate('mobileNumber')?.hasError('required') &&
            validate('mobileNumber')?.touched
          ">
        {{ t("Thisisrequired") }}
      </mat-error>
      <mat-error *ngIf="
            !validate('mobileNumber')?.hasError('required') &&
            validate('mobileNumber')?.hasError('validatePhoneNumber') &&
            validate('mobileNumber')?.touched
          ">
        {{ t("challenge.InvalidPhoneNumber") }}
      </mat-error>
    </div>
    <div style="margin-top: 20px;">
      <button *ngIf="!showSpinner" [disabled]="profileForm.invalid" fxFlex.gt-sm="100" type="submit" mat-flat-button
        color="primary" style="margin-top: 40px;" class="verify-button">
        {{ t("challenge.Verify") }}
      </button>
      <button *ngIf="showSpinner" fxFlex.gt-sm="100" mat-flat-button color="primary" class="spinner-button">
        <mat-spinner diameter="20" class="mat-spinner-white"></mat-spinner>
      </button>
    </div>
  </form>
</ng-container>